import { render, staticRenderFns } from "./GoodDetailView.vue?vue&type=template&id=5dbcb647&"
import script from "./GoodDetailView.vue?vue&type=script&lang=js&"
export * from "./GoodDetailView.vue?vue&type=script&lang=js&"
import style0 from "./GoodDetailView.vue?vue&type=style&index=0&id=5dbcb647&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports